import React, { useEffect, useState } from "react";
import PointSpreadLoading from "react-loadingg/lib/PointSpreadLoading";
import { Link } from "react-router-dom";
import { getSupermarketsOfferList } from "../../Api/BarestServices";
import { getSearchSuperyProductApi } from "../../Api/ClientServices";
import Grouping from "../../Component/Grouping/Grouping";
import NewDiscount from "../NewDiscount/NewDiscount";
import Style from "./SupermarketCategoryPart.module.css";
import { errorToast } from "../../Toast/Toast";

const SupermarketCategoryPart = (props) => {
  const [offerList, setOfferList] = useState();
  const [showSearchPart, setShowSearchPart] = useState();
  const [searchInput, setSearchInput] = useState("");
  const [searchValue, setSearchValue] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    getSuperMarketDetail();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
function debounce(func, delay) {
    let timeoutId;
    return function (...args) {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => func.apply(this, args), delay);
    };
  }
  const getSuperMarketDetail = async () => {
    getSupermarketsOfferList(props.supId,(succ,res)=>{
      if(succ){
        if(res.status===0){
          errorToast("مشکلی پیش آمده است")
        }else{
          setOfferList(res.products);
        }
      }else{
        console.error(res)
      }
    })
  };
  const getSearchProduct = async (value) => {
  
      if (value.trim() === "") {
        setSearchValue([]);
        setShowSearchPart(false);
        setIsLoading(false);
        return;
      }
  
      setIsLoading(true);  // Set loading state before the API call
      getSearchSuperyProductApi(value, props.supId, (succ, res) => {
        setIsLoading(false);  // Stop loading state after API call is complete
  
        if (succ) {
          if (res.status === 0 || res.product===null || res.status===-2) {
            setSearchValue([]);
            setShowSearchPart(true);
          } else {
            setSearchValue(res.product);
            setShowSearchPart(true);
          }
        } else {
          errorToast(res.message);
          setSearchValue([]);
          setShowSearchPart(false);
        }
      });
    };
    const debouncedSearch = debounce(getSearchProduct, 800);
  return (
    <div>
      {offerList === undefined ? (
        <div className={Style.loading2Test}>
          <PointSpreadLoading color={"#ab0c59"} size={"small"} />
        </div>
      ) : (
        <>
          <div className={Style.searchHolder}>
            <input
              className={Style.search}
              placeholder={"جستجو..."}
              onChange={(e) => debouncedSearch(e.target.value)}
              type={"text"}
            />
            { !showSearchPart ? null : (
              <ul className={Style.searchResult}>
                {searchValue&&searchValue.map((item, index) => {
                  return (
                    <Link
                      to={{
                        pathname: `/product/${item.id}/${item.supplier_id}`,
                        state: item.id,
                      }}
                      className={Style.resultItem}
                      key={index}
                    >
                      <div className={Style.imgHolder}>
                        <img
                          src={`https://cdn.barest.ir/product/m/${item.id}.jpg`}
                          alt="محصولات"
                        />
                      </div>
                      <div className={Style.productInfo}>
                        <h3 className={Style.productName}>{item.name}</h3>
                        {/* <h3 className={Style.supplierName}>
                          <FontAwesomeIcon
                            icon={faShoppingBag}
                            className={Style.shopIcon}
                          />
                          {item.supplier_name}
                        </h3> */}
                        <div className={Style.priceHolder}>
                          {parseInt(item.off_price) === 0 ? null : (
                            <h3 className={Style.offPrice}>
                              {item.off_price}تومان
                            </h3>
                          )}
                          {parseInt(item.off_price) === 0 ? (
                            <h3 className={Style.price}>{item.price}تومان</h3>
                          ) : (
                            <h3 className={Style.ofprice}>{item.price}تومان</h3>
                          )}
                        </div>
                      </div>
                    </Link>
                  );
                })}
                <div className={Style.opacityPart}></div>
              </ul>
            )}
          </div>
          {offerList.length > 0?
          <div className={Style.discount}>
            <br />
            <div className={Style.discountTitle}>
              <h2 className={Style.rightTitle}>تخفیف دار</h2>
              <Link
                to={{ pathname: "/seemore", state: props.supId }}
                className={Style.leftTitle}
              >
                دیدن همه
              </Link>
            </div> 
            <br />
            {offerList === undefined ? (
              <div className={Style.loading2Test}>
                <PointSpreadLoading color={"#ab0c59"} size={"small"} />
              </div>
            ) : (
              <NewDiscount data={offerList} suplierId={props.supId} />
            )}
          </div>
           : null}
          <div className={Style.category}>
            <h2 className={Style.name}>دسته بندی</h2>
            <Grouping data={props.categoryList} supId={props.supId} />
          </div>
        </>
      )}
    </div>
  );
};
export default SupermarketCategoryPart;
